import { ChangeEvent, useEffect, useRef } from 'react';
import { BaseFieldProps } from '../Field';
import './sliderField.scss';

interface SliderFieldProps extends BaseFieldProps {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onMouseUp?: (e: React.MouseEvent<HTMLInputElement>) => void;
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  tagline?: string;
}

const SliderField = ({
  id,
  value = 0,
  min = 0,
  max = 100,
  step = 1,
  tagline,
  onChange,
  onMouseUp,
}: SliderFieldProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.value = value.toString();

      const snappedValue = Math.round(value / step) * step;

      inputRef.current.style.setProperty('--val', snappedValue.toString());
      inputRef.current.style.setProperty('--min', min.toString());
      inputRef.current.style.setProperty('--max', max.toString());
    }
  }, [value, min, max, step]);

  return (
    <div className="a-form-field">
      <input
        ref={inputRef}
        type="range"
        id={id}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(e) => {
          if (onChange) {
            onChange(e);
          }

          const rawValue = parseFloat(e.target.value);
          const snappedValue = Math.round(rawValue / step) * step;

          e.target.style.setProperty('--val', snappedValue.toString());
          e.target.style.setProperty('--min', min.toString());
          e.target.style.setProperty('--max', max.toString());
        }}
        onMouseUp={onMouseUp}
        className="slider-field__input"
      />
      <div className="slider-field__labels">
        <span>{min}</span>
        <span>{max}</span>
      </div>
      <p
        className="u-label-tiny"
        style={{ color: 'var(--fdt-semantic-color-foreground-inactive)' }}
      >
        {tagline}
      </p>
    </div>
  );
};

export default SliderField;
